export const introduce = {
  text: '链上活跃地址量统计了区块链网络中被确认交易的接收地址与发送地址的总量（过滤重复地址与非活动地址）。',
  height: 1200,
};
